export default {
  title: 'Loyalitetstablet',
  headers: {
    customer_frequency: 'Kundefrekvens',
  },
};
